<template>
  <remote-multiselect
    ref="multiselect"
    v-bind="$attrs"
    v-model="forwardValue"
    :multiple="multiple"
    label="name"
    :track-by="trackBy"
    select-label=""
    deselect-label=""
    :serviceFetch="fetchItems"
    resourceName="Label"
    :showAddNewItem="enableAddNewItem && canEditOrgSettings"
    @item-added="onItemAdded"
    :modalComponent="LabelFormModal"
  >
    <template #beforeList2 v-if="activeOption">
      <!-- Opaque background needed since it's sticky above scrollable option rows. -->
      <div class="tw:pt-2 tw:px-2 tw:text-xs tw:bg-[var(--color-slate-900)]">
        <b-form-checkbox v-model="includeInactive" ref="checkbox">
          Include inactive labels
        </b-form-checkbox>
      </div>
    </template>
  </remote-multiselect>
</template>
<script>
import RemoteMultiselect from '@/components/RemoteMultiselect.vue'
import LabelFormModal from './LabelFormModal.vue'
import LabelService from './services/LabelService'
import { mapGetters } from 'vuex'
import { ref } from 'vue'

export default {
  name: 'LabelSelect',
  setup () {
    return {
      LabelFormModal,
    }
  },
  components: {
    RemoteMultiselect
  },
  inheritAttrs: false,
  props: {
    modelValue: [Array, Number, String],
    labelType: String,
    searchInactive: Boolean,
    activeOption: Boolean,
    multiple: {
      type: Boolean,
      default: true
    },
    useTargetId: Boolean,
    enableAddNewItem: {
      type: Boolean,
      default: true
    }
  },
  emits: ['item-added', 'update:modelValue'],
  data () {
    return {
      includeInactive: false
    }
  },
  computed: {
    ...mapGetters(['canEditOrgSettings']),
    forwardValue: {
      get () {
        return this.modelValue
      },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    },
    fetchItems () {
      // returns a function
      return (searchText, value, limit) =>
        LabelService.fetchForSelect(this.labelType, this.searchInactive, this.includeInactive)(searchText, value, limit)
    },
    trackBy () {
      return this.useTargetId ? 'targetId' : 'id'
    }
  },
  watch: {
    includeInactive () {
      this.$refs.multiselect?.refresh?.()
    }
  },
  methods: {
    onItemAdded (item) {
      const itemId = ref(null)
      itemId.value = item.id
      const newValue = item[this.trackBy]
      this.$emit('update:modelValue', this.multiple ? (this.modelValue || []).concat(newValue) : newValue)
      this.$emit('item-added', item)
    }
  }
}
</script>
